import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getEmpresaTransportistaActivos`, method: 'GET', body: null, token: token})
}